import React from 'react';
import {
    VOTE_MAJORITY,
    VOTE_PENDING,
    VOTE_ABSTAIN,
    VOTE_YES,
    VOTE_NO,
    VOTE_OPEN,
    VOTE_CLOSED,
    VOTE_VIEW_LIST,
    VOTE_VIEW_SINGLE,
    PERM_VOTE_VOTE,
    PERM_VOTE_VIEW_OUTCOME,
    VOTE_DRAFT,
} from '../../../helpers/constants';
import CompanyLogoPlaceholder from '../../../assets/images/boardtrac_plus_logo.svg';
import VoteIcon from '../../../assets/images/vote-icon.svg';
import store from '../../../stores/store';
import DocumentLink from './DocumentLink';
import * as utils from '../../../helpers/utils';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { observer } from 'mobx-react';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import {  NO_VOTE_MESSAGE } from '../../../helpers/messageText';

const VoteCard = observer(
    class VoteCard extends React.Component {
        constructor() {
            super();

            this.state = {
                dropdown: false,
                pending1: false,
                pending2: false,
            };
        }

        calculateTimeRemaining = vote => {
            if (vote.VoteType !== VOTE_MAJORITY || vote.VoteStatus === VOTE_CLOSED) {
                return null;
            }

            if (vote.VoteDeadline != null) {
                const deadlineString = vote.VoteDeadline;
                const deadlineFormattedString = deadlineString.replace(' +00:00', 'Z');
                let deadline = Date.parse(deadlineFormattedString);
                let currentDate = new Date();

                let timeRemaining = (deadline - currentDate) / (1000 * 60 * 60 * 24);
                return Math.floor(timeRemaining);
            }
            return null;
        };

        getCurrentCastVote = vote => {
            switch (vote.CurrentCastVote) {
                case VOTE_PENDING:
                    return 'Pending';
                case VOTE_ABSTAIN:
                    return 'Abstain';
                case VOTE_YES:
                    return 'Yes';
                case VOTE_NO:
                    return 'No';
                default:
                    return null;
            }
        };

        getCurrentCastVoteText = vote => {
            switch (vote.CurrentCastVote) {
                case VOTE_PENDING:
                    return 'Yet to vote';
                case VOTE_ABSTAIN:
                    return 'You abstained';
                case VOTE_YES:
                    return 'You voted yes';
                case VOTE_NO:
                    return 'You voted no';
                default:
                    return null;
            }
        };

        getVoteOutcomePercentage = vote => {
            let sum = vote.YesCount + vote.NoCount + vote.AbstainCount + vote.PendingCount;
            if (sum === 0) {
                sum = 100;
            }
            return {
                VOTE_PENDING: Math.floor(vote.PendingCount / sum * 100),
                VOTE_ABSTAIN: Math.floor(vote.AbstainCount / sum * 100),
                VOTE_YES: Math.floor(vote.YesCount / sum * 100),
                VOTE_NO: Math.floor(vote.NoCount / sum * 100),
            };
        };

        canViewOutcome = vote => {
            return (vote.VotePermissions & PERM_VOTE_VIEW_OUTCOME) === PERM_VOTE_VIEW_OUTCOME;
        };

        permittedToVote = vote => {
            return (vote.VotePermissions & PERM_VOTE_VOTE) === PERM_VOTE_VOTE;
        };

        canVote = vote => {
            return (
                this.permittedToVote(vote) &&
                vote.VoteStatus === VOTE_OPEN &&
                (vote.CurrentCastVote === VOTE_PENDING || vote.VoteChangeable)
            );
        };

        toggleDropdown = vote => {
            if (this.canVote(vote)) {
                this.setState({ dropdown: !this.state.dropdown });
            }
        };

        castVote = (vote, voteCast) => {
            store.votes.castVote(vote.InstanceId, vote.GroupId, vote.VoteId, voteCast);
            this.toggleDropdown(vote);
        };

        selectGroup = () => {
            const index = store.companies.indexFromId(this.props.detail.InstanceId);
            store.groups.toggleSelected(this.props.detail.GroupId, index);
        };

        onClick = () => {
            let { detail, viewType, selectVote, history } = this.props;
            if (viewType === VOTE_VIEW_LIST) {
                selectVote(detail.InstanceId, detail.GroupId, detail.VoteId, history);
            }
        };

        selectAuthorised = async AuthorisedId => {
            this.setState({
                pending1: true,
                pending2: true,
            });

            // If you select the same authorisation id then we switch it to zero which means in progress
            if (AuthorisedId === this.props.detail.DraftStatus) {
                AuthorisedId = 0;
            }

            await store.votes
                .responseAuthorisation(
                    Number(this.props.detail.InstanceId),
                    Number(this.props.detail.GroupId),
                    Number(this.props.detail.VoteId),
                    Number(AuthorisedId),
                )
                .then(json => {
                    this.setState({
                        pending1: false,
                        pending2: false,
                    });
                }).catch(err => {
                    this.setState({
                        pending1: false,
                        pending2: false,
                    });
                    console.log("Authorising error (vote): ", err.spread.Message);
                });
            if (this.props.onChange) this.props.onChange();
        };

        renderAuthorisation = () => {
            const vote = this.props.detail;

            return (
                <tr>
                    <th scope="row">Approval:</th>
                    <td>
                        <div
                            className={'btn-group btn-group-sm btn-group-toggle'}
                            data-toggle="buttons"
                        >
                            {store.conn.isOnline ? (
                                <div
                                    className="btn-group btn-group-sm btn-group-toggle"
                                    data-toggle="buttons"
                                    id="Authorisation"
                                >
                                    <LaddaButton
                                        className={
                                            vote.DraftStatus === '1'
                                                ? 'btn btn-outline-secondary active'
                                                : 'btn btn-outline-secondary'
                                        }
                                        aria-pressed="true"
                                        loading={this.state.pending1}
                                        onClick={() => this.selectAuthorised(1)}
                                        disabled={this.state.pending1}
                                        data-size={S}
                                        data-style={SLIDE_LEFT}
                                        data-spinner-size={30}
                                        data-spinner-color="#000"
                                        data-spinner-lines={12}
                                        id="lblAuthorised"
                                    >
                                        Authorised
                                    </LaddaButton>

                                    <LaddaButton
                                        className={
                                            vote.DraftStatus === '2'
                                                ? 'btn btn-outline-secondary active'
                                                : 'btn btn-outline-secondary'
                                        }
                                        aria-pressed="true"
                                        loading={this.state.pending2}
                                        onClick={() => this.selectAuthorised(2)}
                                        disabled={this.state.pending2}
                                        data-size={S}
                                        data-style={SLIDE_LEFT}
                                        data-spinner-size={30}
                                        data-spinner-color="#000"
                                        data-spinner-lines={12}
                                        id="lblNotAuthorised"
                                    >
                                        Not authorised
                                    </LaddaButton>
                                </div>
                            ) : (
                                <div className="mt-auto pt-2 pt-xl-0 pl-1">
                                    <button
                                        className="btn btn-sm btn-secondary disabled ml-auto"
                                        type="button"
                                    >
                                        <i className="fa fa-exclamation" aria-hidden="true" />
                                        <span className="pl-3" id="lblNotAuthorised">
                                            OFFLINE
                                        </span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </td>
                </tr>
            );
        };

        render() {
            const vote = this.props.detail;
            const logo = this.props.logo;
            const group = store.groups.getGroup(this.props.instanceId, this.props.detail.GroupId);
            var groupName = '';

            if (group !== null) {
                groupName = group.GroupName;
            }

            const timeRemaining = this.calculateTimeRemaining(vote);
            const voteOutcomePercentage = this.getVoteOutcomePercentage(vote);
            const canViewOutcome = this.canViewOutcome(vote);

            return (
                <div className="col-12 mb-3">
                    <div className={this.props.viewType === VOTE_VIEW_LIST ? 'card' : ''}>
                        <div className="p-2">
                            <div className="row">
                                {this.props.viewType === VOTE_VIEW_SINGLE && (
                                    <a
                                        className="closebtn-meeting"
                                        onClick={() => this.props.voteAnimations()}
                                    >
                                        <i className="fa fa-times-thin fa-lg" aria-hidden="true" />
                                    </a>
                                )}
                                <div className="col-sm-12 col-md-7 col-lg-8">
                                    <div
                                        className="d-flex flex-column align-items-start h-100"
                                        id="votes-list"
                                    >
                                        <table className="table table-sm table-borderless">
                                            <thead>
                                                <tr className="cursor-pointer">
                                                    <th colSpan="2">
                                                        <h6
                                                            className={
                                                                vote.CurrentCastVote ===
                                                                    VOTE_PENDING &&
                                                                this.permittedToVote(vote)
                                                                    ? 'meeting-unread'
                                                                    : ''
                                                            }
                                                            onClick={this.onClick}
                                                        >
                                                            {vote.VoteTopic}
                                                        </h6>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {vote.VotingDocs.length > 0 && (
                                                    <DocumentLink
                                                        instanceId={vote.InstanceId}
                                                        document={vote.VotingDocs[0]}
                                                    />
                                                )}
                                                <tr>
                                                    <th scope="row">Description:</th>
                                                    <td>{vote.VoteDescription}</td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Type of vote:</th>
                                                    <td>{vote.VoteTypeName}</td>
                                                </tr>
                                                {this.props.viewType === VOTE_VIEW_SINGLE &&
                                                    vote.VoteDeadline !== null &&
                                                    vote.VoteStatus < 3 && (
                                                        <tr>
                                                            <th scope="row">Deadline:</th>
                                                            <td>
                                                                {utils.getFormattedDateFromString(
                                                                    vote.VoteDeadline,
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                {this.props.viewType === VOTE_VIEW_SINGLE &&
                                                    vote.VoteClosed !== null && (
                                                        <tr>
                                                            <th scope="row">Closed:</th>
                                                            <td>
                                                                {utils.getFormattedDateFromString(
                                                                    vote.VoteClosed,
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )}
                                                <tr>
                                                    <th scope="row">Time remaining:</th>
                                                    <td>
                                                        {timeRemaining != null && timeRemaining > 0
                                                            ? `${timeRemaining} ${
                                                                  timeRemaining > 1 ? 'days' : 'day'
                                                              }`
                                                            : 'None'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th scope="row">Status:</th>
                                                    <td>
                                                        {utils.capitalizeFirstLetter(
                                                            vote.VoteStatusName,
                                                        )}
                                                    </td>
                                                </tr>

                                                {vote.VoteStatus === VOTE_DRAFT &&
                                                vote.LoginIsLead === 1
                                                    ? this.renderAuthorisation()
                                                    : null}
                                            </tbody>
                                        </table>
                                        {store.conn.isOnline ? (
                                            <div className="dropup mt-auto pt-2 pt-xl-0">
                                                <Dropdown
                                                    dropup={true}
                                                    isOpen={this.state.dropdown}
                                                    toggle={() => this.toggleDropdown(vote)}
                                                >
                                                    <DropdownToggle
                                                        className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                        disabled={!this.canVote(vote)}
                                                    >
                                                        {this.canVote(vote) ? (
                                                            <i className="fa fa-reply pl-2" />
                                                        ) : null}
                                                        <span className="pl-3">
                                                            {this.getCurrentCastVote(vote)}
                                                        </span>
                                                    </DropdownToggle>
                                                    {this.canVote(vote) && (
                                                        <DropdownMenu>
                                                            <DropdownItem
                                                                onClick={() =>
                                                                    this.castVote(vote, VOTE_YES)
                                                                }
                                                            >
                                                                <i className="fa fa-check attendee-response-icon-padding" />
                                                                Yes
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={() =>
                                                                    this.castVote(vote, VOTE_NO)
                                                                }
                                                            >
                                                                <i className="fa fa-question attendee-response-icon-padding" />
                                                                No
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={() =>
                                                                    this.castVote(
                                                                        vote,
                                                                        VOTE_ABSTAIN,
                                                                    )
                                                                }
                                                            >
                                                                <i className="fa fa-times attendee-response-icon-padding" />
                                                                Abstain
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    )}
                                                </Dropdown>
                                            </div>
                                        ) : (
                                            <div className="mt-auto pt-2 pt-xl-0 pl-1">
                                                <button
                                                    className="btn btn-sm btn-secondary disabled ml-auto"
                                                    type="button"
                                                >
                                                    <i
                                                        className="fa fa-exclamation"
                                                        aria-hidden="true"
                                                    />
                                                    <span className="pl-3">OFFLINE</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-sm-12 col-md-5 col-lg-4 ml-auto mt-auto pt-3 pt-md-0">
                                    {!canViewOutcome ? (
                                        <div className="no-vote">
                                            <img
                                                className="my-auto mx-auto img-fluid novote-pic"
                                                src={VoteIcon}
                                                alt="No permission"
                                            />
                                            <br />{NO_VOTE_MESSAGE}
                                        </div>
                                    ) : (
                                        <table className="chart">
                                            <caption>
                                                <span className="text-muted pr-2">
                                                    {this.getCurrentCastVoteText(vote)}
                                                </span>
                                            </caption>
                                            <thead>
                                                <tr>
                                                    <th className="xLabel" />
                                                </tr>
                                            </thead>
                                            <tbody className="body">
                                                <tr>
                                                    <td className="bar-label" title="Yes">
                                                        Yes
                                                    </td>
                                                    <td
                                                        className="bar vote-yes"
                                                        style={{
                                                            height: `${
                                                                voteOutcomePercentage.VOTE_YES
                                                            }%`,
                                                        }}
                                                    >
                                                        <span className="vote-stat-label">
                                                            {voteOutcomePercentage.VOTE_YES}%
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="bar-label" title="No">
                                                        No
                                                    </td>
                                                    <td
                                                        className="bar vote-no"
                                                        style={{
                                                            height: `${
                                                                voteOutcomePercentage.VOTE_NO
                                                            }%`,
                                                        }}
                                                    >
                                                        <span className="vote-stat-label">
                                                            {voteOutcomePercentage.VOTE_NO}%
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="bar-label" title="Abstain">
                                                        Abstain
                                                    </td>
                                                    <td
                                                        className="bar vote-abstain"
                                                        style={{
                                                            height: `${
                                                                voteOutcomePercentage.VOTE_ABSTAIN
                                                            }%`,
                                                        }}
                                                    >
                                                        <span className="vote-stat-label">
                                                            {voteOutcomePercentage.VOTE_ABSTAIN}%
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="bar-label" title="Pending">
                                                        Pending
                                                    </td>
                                                    <td
                                                        className="bar vote-pending"
                                                        style={{
                                                            height: `${
                                                                voteOutcomePercentage.VOTE_PENDING
                                                            }%`,
                                                        }}
                                                    >
                                                        <span className="vote-stat-label">
                                                            {voteOutcomePercentage.VOTE_PENDING}%
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                        {this.props.viewType === VOTE_VIEW_LIST && (
                            <div className="card-footer">
                                <div className="d-flex justify-content-start">
                                    <div className="footer-img text-center">
                                        <img
                                            className="my-auto mx-auto img-fluid"
                                            src={logo ? logo : CompanyLogoPlaceholder}
                                            alt="company logo"
                                        />{' '}
                                    </div>{' '}
                                    <div
                                        className="small text-muted d-flex align-items-center cursor-pointer"
                                        onClick={() => this.selectGroup()}
                                    >
                                        {' '}
                                        {groupName}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            );
        }
    },
);
export default VoteCard;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Vote/VoteCard.js